import * as ACTION_TYPES from './Types';

const initialState = {
  customers: {},
  message: '',
  error: null,
}

export const customersReducer = (state = initialState, action) => {
  switch (action.type) {

    case ACTION_TYPES.GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        customers: action.payload.data,
        message: action.payload.message,
      }
    case ACTION_TYPES.CHANGEACTION_SUCCESS:
      return {
        ...state,
        manufacturers: action.payload.data,
        message: action.payload.message,
      }
    case ACTION_TYPES.GET_CUSTOMER_ERROR:
    case ACTION_TYPES.CHANGEACTION_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
